import { TextField } from "@mui/material";
import type { PropsWithChildren, ReactNode, SelectHTMLAttributes } from "react";

export type SelectProps = PropsWithChildren<
  Pick<
    SelectHTMLAttributes<HTMLInputElement>,
    "id" | "name" | "value" | "disabled" | "onChange" | "onBlur" | "onFocus"
  > & {
    label?: ReactNode;
    placeholder?: string;
    error?: boolean;
    helperText?: ReactNode;
    ref?: React.Ref<HTMLInputElement>;
  }
>;

export function Select({ children, ...props }: SelectProps) {
  return (
    <TextField {...props} hiddenLabel={!props.label} fullWidth select>
      {children}
    </TextField>
  );
}
